import React, { useEffect, useState }  from 'react';
import Papa from 'papaparse';
import MobilityCard from './MobilityCard';
import File from '../../Assets/Spreadsheets/Mobility.csv';
import '../Pages.css';

function Mobility() {
  const [fileData, setFileData] = useState([]);
  const [fileKeys, setFileKeys] = useState([]);
  const [fileValues, setFileValues] = useState([]);

  async function fetchData() {
    try {
      const response = await fetch(File);

      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }
  
      const blob = await response.blob();
      Papa.parse(blob, {
        header:true,
        skipEmptyLines:true,
        complete: function (res) {
          setFileData(res.data);
          console.log('data', fileData);
          setFileKeys(fileData.map(i => Object.keys(i)))
          setFileValues(fileData.map(i => Object.values(i)))
          
          console.log('keys', fileKeys);
          console.log('values', fileValues);
        }
      })
    } catch (error) {
      console.error(error.message);
    }
  }
  
  useEffect(() => {
    fetchData()
  }, []);

  return (
    <div className='page' id='mobility'>
      {fileData.map((i, idx) => <MobilityCard item={i} index={idx} />)}
    </div>
  )
}

export default Mobility